/**
 * @generated SignedSource<<c3ec7c905e5281553606fc0b031e6f08>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addQuoteRulePanel_AssignProductMutation$variables = {
  productIds: ReadonlyArray<number>;
  ruleId: string;
};
export type addQuoteRulePanel_AssignProductMutation$data = {
  readonly assignProductsToQuoteRule: {
    readonly result: boolean;
  };
};
export type addQuoteRulePanel_AssignProductMutation = {
  response: addQuoteRulePanel_AssignProductMutation$data;
  variables: addQuoteRulePanel_AssignProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "ruleId",
        "variableName": "ruleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "assignProductsToQuoteRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "addQuoteRulePanel_AssignProductMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "addQuoteRulePanel_AssignProductMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "896866eb0755abed45332e9b5f27f2a1",
    "id": null,
    "metadata": {},
    "name": "addQuoteRulePanel_AssignProductMutation",
    "operationKind": "mutation",
    "text": "mutation addQuoteRulePanel_AssignProductMutation(\n  $ruleId: ID!\n  $productIds: [Long!]!\n) {\n  assignProductsToQuoteRule(ruleId: $ruleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "b49ae4f14bf56ce94a082a78c89fec64";

export default node;
